<template>
  <ul :class="stepListClasses">
    <li v-for="(step, index) in steps" :key="index" :class="itemClasses(index)">
      <span class="num">
        {{ index + 1 }}
      </span>
      {{ step.name }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TkStepList',
  props: {
    steps: {
      type: Array,
      required: true,
    },
    stepItemClasses: {
      type: String,
      default: '',
    },
    stepListClasses: {
      type: String,
      default: '',
    },
  },
  computed: {
    lastSelectedStepIndex() {
      const lastSelectedItem = this.steps.filter((e) => e.isSelected)
      return lastSelectedItem.length > 0 ? lastSelectedItem.length - 1 : 0
    },
  },
  methods: {
    itemClasses(index) {
      const itemClasses = [this.stepItemClasses]
      if (index < this.lastSelectedStepIndex) {
        itemClasses.push('visited')
      } else if (index === this.lastSelectedStepIndex) {
        itemClasses.push('active')
      }
      return itemClasses
    },
  },
}
</script>
